module.exports = __webpack_public_path__ + "static/media/medium_linee.745d7c67.svg";